module.exports = __webpack_public_path__ + "img/holding_scissors_splash.c3f510f5.jpg";